import { FC } from 'react'
import s from './index.module.less'
import { connect } from 'react-redux'
import { Tooltip } from 'antd'
import { getUserBenefit } from "@/api/index";
import { checkLogin } from "@/utils/common";
import Avatar from "@/componentsNew/Avatar/index";
import LogoImg from '@/assets/images/Ai.3d66@2x.png';
import { useNavigate } from 'react-router-dom';
import { LlwMemberLocationClick } from "@/utils/sensorsFunc";
import { CHANNEL_CODE } from '@/consts/newConsts'
import RechargeInfo from './RechargeInfo'

interface HeadProps {
  userInfo: any
  setMemberLocation: (location: any) => void
  setVipRechargeModalVisible: (visible: boolean) => void
  setVipRechargeTab: (tab: string) => void
  ai_source: string
  fromLiuYunKu: boolean
}
const TEACH_LINK = 'https://noo85nqwpa.feishu.cn/wiki/PW2AwyaiciSfopkpPmicv0PGn4f?fromScene=spaceOverview' // 新手引导链接
const HeaderBar: FC<HeadProps> = (props) => {
  const { userInfo,  setMemberLocation, setVipRechargeModalVisible, setVipRechargeTab,  ai_source, fromLiuYunKu} = props
  const navigate = useNavigate()



  // 续费/开通VIP
  const openVipRechargeModal = () => {
    if (!checkLogin()) return
    setMemberLocation(userInfo.is_vip ? 16 : 15)
    setVipRechargeTab('vip')
    getUserBenefit().then((res) => {
      LlwMemberLocationClick({
        is_recharge_xzb: res.data.is_recharge_xzb,
      })
    })
    setVipRechargeModalVisible(true)
  }
  // 购买算力（默认打开算力tab）
  const openTopsRechargeModal = () => {
    if (!checkLogin()) return
    setVipRechargeTab('power')
    setVipRechargeModalVisible(true)
  }
  // 来源插件
  const isFromPlug = Object.values(CHANNEL_CODE).includes(ai_source);
  const goIndex = () => {
    if(isFromPlug) return
    const indexUrl = '/pro/Home'
    if(ai_source && ai_source != '4'){
      navigate(indexUrl + '?ai_source=' + ai_source);
      return
    }
    navigate(indexUrl);
  }

  return (
    <div className={s.root} >
      <div className='projectOpBox'>
        <div className='logo' onClick={goIndex}>
            <img src={LogoImg} alt=""/>
        </div>
      </div>
      <div className='canvasOpBox'>
        <div className='canvasOpBoxCon'>
         
          <div className={s.opBtn}>
            <Tooltip title='新手教学' overlayClassName='toolTip3'>
              <a href={TEACH_LINK} target='_blank'  rel="noreferrer">
                <i className='iconfont icon-doubt'></i>
              </a>
            </Tooltip>
          </div>
          <RechargeInfo userInfo={userInfo} openVipRechargeModal={openVipRechargeModal} onBuyTopsClick={openTopsRechargeModal} />
          {
            fromLiuYunKu === false && <Avatar size={30} isSkipUserCenter={!isFromPlug}/>
          }
        </div>
      </div>
    </div>
  )
}
const mapStateToProps = ({ edit, app }: any) => {
  return {
    reDrawMode: edit.reDrawMode,
    userInfo: app.userInfo,
    fromLiuYunKu: [6, 7, 10, 11, 12].includes(+app.ai_source), // 是否在溜云库中打开
    ai_source: app.ai_source,
    scale: edit.scale,
    isDragging: edit.isDragging,
    currentProjectName:edit.currentProjectName,
    selectedCardData: edit.selectedCardData,
    isMobileDevice: app.isMobileDevice,
    reDrawLoading: edit.reDrawLoading,
    isSaved: edit.isSaved,
    selectImgsListObj: edit.selectImgsListObj,
  }
}
const mapDispatchToProps = (dispatch: any) => {
  return {
    setMemberLocation: (params: any) => {
      return dispatch({
        type: 'app/setMemberLocation',
        payload: params,
      })
    },
    setVipRechargeModalVisible: (params: any) => {
      return dispatch({
        type: 'app/setVipRechargeModalVisible',
        payload: params,
      })
    },
    setVipRechargeTab: (params: any) => {
      return dispatch({
        type: 'app/setVipRechargeTab',
        payload: params,
      })
    },
    setIsDragging: (status: boolean) => {
      return dispatch({
        type: 'edit/setIsDragging',
        payload: status,
      })
    },
    setCurrentProjectId: (id: number|string) => {
      return dispatch({
        type: 'edit/setCurrentProjectId',
        payload: id,
      })
    },
    setCurrentProjectName: (name: string) => {
      return dispatch({
        type: 'edit/setCurrentProjectName',
        payload: name,
      })
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(HeaderBar)
